import ReprocessingIcon from 'components/ReusableComponents/Icons/ReprocessingIcon'

import styles from './MaintenanceBar.module.scss'

/** Single switch to turn the analytics maintenance message on and off. */
export const isAnalyticsMaintenanceActive = false

const estimatedCompletionTimes = [
  { zone: 'PST', hours: '11:00 AM – 7:00 PM' },
  { zone: 'CST', hours: '1:00 PM – 9:00 PM' },
  { zone: 'EST', hours: '2:00 PM – 10:00 PM' }
]

const MaintenanceBar = ({ marginBottom = 0, marginTop = 25 }) => {
  if (!isAnalyticsMaintenanceActive) return null

  return (
    <div className={styles.bar} style={{ marginBottom, marginTop }}>
      <div className={styles.iconHolder}>
        <ReprocessingIcon />
      </div>
      <div className={styles.textHolder}>
        <p className={styles.title}>Analytics Maintenance</p>
        <p className={styles.description}>
          Analytics is currently undergoing scheduled maintenance. We expect the service to
          be fully restored within 8 hours.
        </p>
        <p className={styles.subTitle}>Estimated completion time:</p>
        <ul className={styles.times}>
          {estimatedCompletionTimes.map(time => (
            <li key={time.zone} className={styles.time}>
              <span className={styles.zone}>{time.zone}:</span> {time.hours}
            </li>
          ))}
        </ul>
        <p className={styles.description}>
          We appreciate your patience and understanding while we complete the maintenance.
        </p>
      </div>
    </div>
  )
}

export default MaintenanceBar
